export const NASTRING = 'N/A';
export const EMPTY_STRING = '\u00A0';
export const TRANSACTION_STRING = 'Transaction';
export const SAVING_BUILDER = 'savingsBuilder';
export const SUCCESS_STRING = 'SUCCESS';
export const COMPLETE_STRING = 'COMPLETE';
export const RUN_REGISTRATION='RUN_REGISTRATION';
export const GIVE_EXTRA_PLAID_ATTEMPT='GIVE_EXTRA_PLAID_ATTEMPT';
export const GOOGLE_PROVIDER = 'google.com';
export const EMAIL_PROVIDER = 'password';
export const APPLE_PROVIDER = 'apple.com';


